import { AutomationTypeEnum } from '@/store/modules/automation/types'
import { CountryEnum, ModeEnum, StayListColumns } from '@/store/modules/settings/types'

/**
 * Column names must be synced with backend/src/Resources/schemas/user_settings.json
 */
const AvailableColumns: StayListColumns = {
  notification: {
    icon: 'bell-fill',
    name: 'Notification',
    label: 'Notification',
    country: [CountryEnum.FR],
    order: 'notification',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: true,
    invertedOrder: false,
    columnGroup: 'sancareState',
  },
  legalFiness: {
    label: 'Finess juridique',
    country: [CountryEnum.FR],
    order: 'legalFiness',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'administrativeInfo',
  },
  geoFiness: {
    label: 'Finess géographique',
    country: [CountryEnum.FR],
    order: 'geoFiness',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'administrativeInfo',
  },
  administrativeLocalStayId: {
    label: 'N° administratif',
    country: [CountryEnum.FR],
    order: 'administrativeLocalStayId',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: true,
    invertedOrder: false,
    columnGroup: 'administrativeInfo',
  },
  patientName: {
    name: 'Patient',
    label: 'Nom - Prénom',
    country: [CountryEnum.FR],
    order: 'patientName',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    automationType: [AutomationTypeEnum.AI, AutomationTypeEnum.RULES],
    isDefault: true,
    invertedOrder: false,
    columnGroup: 'administrativeInfo',
  },
  hospitalizationType: {
    label: 'Type d\'hospitalisation',
    country: [CountryEnum.FR],
    order: 'hospitalizationType',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'administrativeInfo',
  },
  stayStart: {
    label: 'Date d\'entrée',
    country: [CountryEnum.FR],
    order: 'stayStart',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'administrativeInfo',
  },
  stayEnd: {
    label: 'Date de sortie',
    country: [CountryEnum.FR],
    order: 'stayEnd',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: true,
    invertedOrder: false,
    columnGroup: 'administrativeInfo',
  },
  initialGme: {
    label: 'GME pré-revalo.',
    country: [CountryEnum.FR],
    order: 'initialGme',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: true,
    invertedOrder: false,
    columnGroup: 'initialGrouping',
  },
  initialGmeCmGn: {
    label: 'CM/GN pré-revalo.',
    country: [CountryEnum.FR],
    order: 'initialGmeCmGn',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'initialGrouping',
  },
  initialGmeReadaptationType: {
    label: 'Type réadaptation pré-revalo.',
    country: [CountryEnum.FR],
    order: 'initialGmeReadaptationType',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'initialGrouping',
  },
  initialGmeHeaviness: {
    label: 'Lourdeur pré-revalo.',
    country: [CountryEnum.FR],
    order: 'initialGmeHeaviness',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'initialGrouping',
  },
  initialGmeSeverity: {
    label: 'Sévérité pré-revalo.',
    country: [CountryEnum.FR],
    order: 'initialGmeSeverity',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'initialGrouping',
  },
  currentGme: {
    label: 'GME',
    country: [CountryEnum.FR],
    order: 'currentGme',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: true,
    invertedOrder: false,
    columnGroup: 'currentGrouping',
  },
  currentGmeCmGn: {
    label: 'CM/GN',
    country: [CountryEnum.FR],
    order: 'currentGmeCmGn',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'currentGrouping',
  },
  currentGmeReadaptationType: {
    label: 'Type réadaptation',
    country: [CountryEnum.FR],
    order: 'currentGmeReadaptationType',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'currentGrouping',
  },
  currentGmeHeaviness: {
    label: 'Lourdeur',
    country: [CountryEnum.FR],
    order: 'currentGmeHeaviness',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'currentGrouping',
  },
  currentGmeSeverity: {
    label: 'Sévérité',
    country: [CountryEnum.FR],
    order: 'currentGmeSeverity',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'currentGrouping',
  },
  status: {
    label: 'Statut',
    country: [CountryEnum.FR],
    order: 'status',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    automationType: [AutomationTypeEnum.AI, AutomationTypeEnum.RULES],
    isDefault: true,
    invertedOrder: false,
    columnGroup: 'sancareState',
  },
  latestSurgeryDate: {
    label: 'Date dernière intervention chirurgicale',
    country: [CountryEnum.FR],
    order: 'latestSurgeryDate',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'administrativeInfo',
  },
  addedDasCount: {
    label: 'Nombre de DAS ajoutés',
    country: [CountryEnum.FR],
    order: null,
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'currentGrouping',
  },
  addedDas: {
    label: 'Tous les DAS ajoutés depuis Sancare',
    country: [CountryEnum.FR],
    order: null,
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'currentGrouping',
  },
  firstValue: {
    isTranslated: false,
    label: 'Tarif GME pré-revalo.',
    country: [CountryEnum.FR],
    order: 'startingValue',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: true,
    invertedOrder: true,
    columnGroup: 'initialGrouping',
  },
  currentValue: {
    isTranslated: false,
    label: 'Tarif',
    country: [CountryEnum.FR],
    order: 'currentValue',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: true,
    invertedOrder: true,
    columnGroup: 'currentGrouping',
  },
  moneyGap: {
    label: 'Montant revalorisé',
    country: [CountryEnum.FR],
    order: 'moneyGap',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: true,
    columnGroup: 'currentGrouping',
  },
  heavinessMoneyGap: {
    label: 'Gains de lourdeur',
    country: [CountryEnum.FR],
    order: null,
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: true,
    columnGroup: 'currentGrouping',
  },
  severityMoneyGap: {
    label: 'Gains de sévérité',
    country: [CountryEnum.FR],
    order: null,
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: true,
    columnGroup: 'currentGrouping',
  },
  rhsCount: {
    label: 'Nombre de RHS',
    country: [CountryEnum.FR],
    order: 'rhsCount',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: true,
    invertedOrder: true,
    columnGroup: 'administrativeInfo',
  },
  validationDate: {
    label: 'Date de validation',
    country: [CountryEnum.FR],
    order: 'validationDate',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'sancareState',
  },
  stayDuration: {
    label: 'Durée de séjour',
    country: [CountryEnum.FR],
    order: 'stayDuration',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: true,
    invertedOrder: true,
    columnGroup: 'administrativeInfo',
  },
  countSavedSearches: {
    label: 'Nombre de recherches',
    country: [CountryEnum.FR],
    order: null,
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: true,
    columnGroup: 'sancareCodingAssistance',
  },
  savedSearches: {
    label: 'Recherches',
    country: [CountryEnum.FR],
    order: null,
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'sancareCodingAssistance',
  },
  comment: {
    label: 'Commentaire',
    country: [CountryEnum.FR],
    order: 'comment',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'sancareState',
  },
  seen: {
    label: 'Vu',
    country: [CountryEnum.FR],
    order: 'seen',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: true,
    invertedOrder: false,
    columnGroup: 'sancareState',
  },
  groupingError: {
    label: 'Libellés des codes erreur de groupage',
    country: [CountryEnum.FR],
    order: 'groupingError',
    mode: [ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'currentGrouping',
  },
}

export default AvailableColumns
